<template>
  <div class="justify-content-center align-items-center">
    <div class="text-center mt-4 px-4">
      <div class="dialog-header">
        <icon :type="this.type" class="mb-4" height="60" />
      </div>
      <h1 :class="{'mb-1': this.whatIfOption, '': !this.whatIfOption}">{{ popupContent.title }}</h1>
      <h4 class="sub-heading mb-4" v-if="this.whatIfOption">{{ this.whatIfOption.optionName }}</h4>
      <p>{{ popupContent.description }}</p>
      <div class="row justify-content-center align-items-center mt-5">
        <div class="col-6" v-if="!this.popupContent.hideConfirmBtt">
          <k-button
            class="btn btn-lg btn-secondary w-100"
            @click="onClickConfirm()"
            :disabled="this.popupContent.disabledConfirmBtt"
            >{{ this.popupContent.confirmBttText }}</k-button
          >
        </div>
        <div class="col-6" v-if="!this.popupContent.hideCloseBtt">
          <k-button
            class="btn btn-lg btn-outline-primary w-100"
            @click="$emit('closePopup')"
            :disabled="this.popupContent.disabledCloseBtt"
            >{{ this.popupContent.closeBttText }}</k-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../components/Icon.vue";

export default {
  name: "PopupContentComponent",
  components: {
    icon
  },
  props: {
    popupContent: Object,
    type: String,
    whatIfOption: Object
  },
  methods: {
    onClickConfirm() {
      if (this.whatIfOption) {
        this.$emit("confirmPopup", this.whatIfOption.whatIfOptionID)
      }
      else {
        this.$emit("confirmPopup");
      }
    }
  }
};
</script>
